import { ReactNode } from "react";

import { Group } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";
import { SimplifiedValue } from "@/utils/medplum";

const AnswerItem = ({
  label,
  value,
}: {
  label: string;
  value: SimplifiedValue | SimplifiedValue[] | ReactNode | ReactNode[];
}) => {
  return (
    <Group>
      <TextWrapper fw={600} c="dark.2" miw={{ base: 150, md: 450 }}>
        {label}
      </TextWrapper>
      <TextWrapper c="dark.9">{value}</TextWrapper>
    </Group>
  );
};

export { AnswerItem };
